<div class="chart-name-holder" #check>
  <div class="input-with-action" *ngIf="inEditMode; else displayName">
    <input
      #chartRename
      nz-input
      nzSize="small"
      placeholder="Enter Chart Name"
      [title]="chartName"
      [(ngModel)]="chartName"
      maxlength="100"
      (keyup)="onNameChange()"
      [class.in-edit-mode]="inEditMode"
    />
    <div
      class="save-edit-holder toggle-icon-onhover"
      [class.in-edit-mode]="inEditMode"
      (click)="toggleEditMode()"
    >
      <va-icon size="small" name="save"> </va-icon>
      <va-icon size="small" name="save"> </va-icon>
    </div>
  </div>
  <span class="error-color watchlist-name-error" [hidden]="nameError === ''">
    <va-icon size="small" name="exclamation-triangle" class="alerts-icon"></va-icon>
    {{ nameError }}
  </span>
  <ng-template #displayName>
    <div class="input-with-action">
      <div class="display-name" (click)="setEditMode()" [title]="chartName">
        {{ chartName }}
      </div>
      <div
        class="save-edit-holder toggle-icon-onhover"
        style="border-bottom: 1px solid #36abad"
        [class.in-edit-mode]="inEditMode"
        (click)="toggleEditMode()"
      >
        <va-icon name="edit" size="small"> </va-icon>
        <va-icon name="edit" size="small"> </va-icon>
      </div>
    </div>
  </ng-template>
</div>
